import { useState, useEffect } from 'react';
import { DEVICE } from '@/constants';
import {
  callNativeFunction,
  nativeFunction,
  OS,
} from '@/utils/detectDevice';
import VERSION_NAME, { greaterAndEqualThan } from '@/utils/historyVersion';
import { soundsPath, SOUNDS_SIZE } from '@/utils/sounds';


const useSoundEffect = () => {
  const [downlodedSoundEffectSize, setDownlodedSoundEffectSize] = useState(0);
  const [isDownloadedSoundEffect, setIsDownloadedSoundEffect] = useState(false);

  const handleDownLoad = () => {
    if (OS.TYPE !== DEVICE.PC && greaterAndEqualThan(VERSION_NAME.LIBRARY_SOUND_EFFECT)) {
      callNativeFunction(nativeFunction.CHECK_LOCAL_SOUNDS)({
        path: soundsPath,
        size: SOUNDS_SIZE,
      });
      window.onfire.on('setDownloadSoundsProgress', ({ progress: current }) => {
        setDownlodedSoundEffectSize((current / 100) * SOUNDS_SIZE);
      });
    }
  };

  useEffect(() => {
    handleDownLoad();
    return () => {
      window.onfire.off('setDownloadSoundsProgress');
    };
  }, []);

  useEffect(() => {
    setIsDownloadedSoundEffect(downlodedSoundEffectSize === SOUNDS_SIZE);
  }, [downlodedSoundEffectSize]);

  return {
    SOUNDS_SIZE,
    downlodedSoundEffectSize,
    isDownloadedSoundEffect,
  };
};

export default useSoundEffect;
